import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from "@angular/core";
import { NgxJsonViewerModule } from "ngx-json-viewer";

@Component({
  selector: "app-webhook-request-body",
  templateUrl: "./webhook-request-body.component.html",
  styleUrls: ["./webhook-request-body.component.scss"],
  imports: [NgxJsonViewerModule]
})
export class WebhookRequestBodyComponent implements OnInit, OnChanges {
  @Input()
  public requestbodyjson: string;

  public requestBody: object = { test: "123" };

  ngOnInit() {
    console.log("Unescaping", this.requestbodyjson);
    if (this.requestbodyjson) {
      console.log("Parsing", unescape(this.requestbodyjson));
      console.log("Parsed", JSON.parse(unescape(this.requestbodyjson)));

      this.requestBody = JSON.parse(unescape(this.requestbodyjson));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Unescaping", this.requestbodyjson);
    if (this.requestbodyjson) {
      console.log("Parsing", unescape(this.requestbodyjson));
      console.log("Parsed", JSON.parse(unescape(this.requestbodyjson)));

      this.requestBody = JSON.parse(unescape(this.requestbodyjson));
    }
  }
}
